import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
// import { withStyles } from '@mui/material';
import { AppBar, useRecordContext } from "react-admin";
// import BackButton from './backButton'
import {
  List,
  Toolbar,
  Edit,
  ListActions,
  ListButton,
  TopToolbar,
  Pagination,
  Create,
  SimpleForm,
  TextInput,
  email,
  BooleanField,
  Link,
  Button,
  SelectInput,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  DeleteButton,
  ShowButton,
  DateField,
} from "react-admin";

const StatusField = ({ source }) => {
  const record = useRecordContext();

  return (
    <span>
      {record[source] === "-" ? "-" : record[source] ? "Active" : "Inactive"}
    </span>
  );
};

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ permissions, basePath, data, resource }) => (
  <TopToolbar>
    <ListButton resource="whitelist_users" />
  </TopToolbar>
);

export const ChangeLogList = ({ permissions, ...props }) => (
  <Scrollbars className="scroll-container">
    {/* <BackButton/> */}
    <List title="User logs" actions={<EditActions />}>
      <Datagrid bulkActionButtons={false}>
        <TextField source="updateBy" />
        <DateField source="updated_on" showTime />
        <TextField source="name" />
        <TextField source="email" />
        <StatusField source="status" />
        <TextField source="userRole" />
      </Datagrid>
    </List>
  </Scrollbars>
);
